import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import { useSidebar } from '../contexts/SidebarContext';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/review/')) setIsSidebarOpen(false);
  }, [pathname, setIsSidebarOpen]);

  return (
    <div className="workspace-shell min-h-screen">
      <Header />
      <main
        className={`pt-16 transition-all duration-300 ${
          isSidebarOpen ? 'xl:ml-64' : 'ml-0'
        }`}
      >
        {children}
      </main>
    </div>
  );
}
